import { Component } from '@angular/core';

@Component({
  selector: 'app-web-navbar',
  templateUrl: './web-navbar.component.html',
  styleUrl: './web-navbar.component.scss'
})
export class WebNavbarComponent {

}
